module.exports = __webpack_public_path__ + "static/img/vod-bn-4.ba9ee19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-4.jpg
// module id = Rkok
// module chunks = 1